import { UniversalMenuItem } from '@klv/molecules/universal-menu-item';
import { generateClassName } from '@klv/shared/utils/functions';

import * as menuItemStyles from '@klv/molecules/universal-menu-item/styles/universalMenuItem.module.scss';
import * as styles from './styles/list.module.css';

import type { IUniversalMenuItemWithCustomFields } from '@klaviyo-mkt/gatsby-source-universal-navigation/src/types';
import { gtmClick } from '../../utils';


export const List = ({
  callToAction = {
    text: '',
    url: '',
  },
  childItems = [],
  className,
  drawerPosition = 'upper',
  eyebrow,
  id,
  label = '',
  parentLabel,
  type,
  width,
  url,
  ...rest
}: { className?: string; drawerPosition?: 'lower' | 'upper'; parentLabel?: string; } & IUniversalMenuItemWithCustomFields) => {

  return (
    <li
      className={generateClassName([
        className,
        styles[drawerPosition],
        styles.list,
        type && styles[type],
        width && styles[width],
      ])}
      key={id}
    >
      {eyebrow && (<div className={styles.eyebrow}>{eyebrow}</div>)}
      {(label !== '#' && label !== '') && (
        <UniversalMenuItem
          className={styles.label}
          href={url}
          label={label}
          onClick={() => { gtmClick({ childItem: label, menuItem: parentLabel }); }}
          {...rest}
        />
      )}
      {childItems?.length > 0 && (
        <ul className={styles.childList}>
          {childItems.map(({ childItems: childChildItems, id: childId, label: childLabel, url: childHref, ...childRest }) => (
            <li key={childId}>
              <UniversalMenuItem
                className={type === 'visual_list' ? menuItemStyles.visualList : undefined}
                href={childHref}
                label={type === 'visual_list' ? '' : childLabel}
                onClick={() => { gtmClick({ childItem: childLabel, menuItem: parentLabel }); }}
                {...childRest}
              />
            </li>
          ))}
        </ul>
      )}
      {(callToAction.text && callToAction.url) && (
        <UniversalMenuItem
          className={styles.callToAction}
          href={callToAction.url}
          label={callToAction.text}
        />
      )}
    </li>
  );
};
